<template>
  <div class="accordion-items">
    <div class="d-flex align-content-between align-items-center justify-content-between">
      <b-button
        v-b-toggle="'accordion-'+group.id"
        :variant="'empty'"
        class="d-flex align-content-between align-items-center font-weight-normal accordion-toggle"
      >
        <strong>{{ group.name }} ({{ group.children.length }})</strong>
        <font-awesome-icon class="mx-2" size="xs" :icon="'chevron-right'" />
      </b-button>
      <b-button :variant="'link'" @click="$emit('removeGroup', group.name)">
        {{ $t('Remove All') }}
      </b-button>
    </div>
    <b-collapse
      :id="'accordion-'+group.id"
      :ref="'wta-'+group.id"
      :accordion="'my-accordion-worktypes'"
      role="tabpanel"
    >
      <ul class="list-unstyled ml-3">
        <li v-for="(wt, wtid) in group.children" :key="wtid" class="cursor-pointer m-1" @click.prevent.stop="$emit('remove', wt)">
          <b-checkbox :checked="true" class="forced-pointer">
            {{ getDescriptionTranslation(wt) }}
          </b-checkbox>
        </li>
      </ul>
    </b-collapse>
  </div>
</template>

<script>
import workTypeTranslation from "@/imports/mixins/workTypeTranslation";
import company from "@/imports/mixins/company";

export default {
  name: "WorkTypeAccordion",
  mixins: [workTypeTranslation, company],
  props: ['group'],
  data: function() {
    return {
      internal: null,
    }
  },
  methods: {
    hasChanged: function(value) {
      return JSON.stringify(value) !== JSON.stringify(this.internal)
    }
  },
  watch: {
    group: function(value) {
      if (this.hasChanged(value)) {
        this.$refs['wta-'+this.group.id].show = true;
        this.internal = value;
      }
    }
  },
  mounted: function() {
    this.$refs['wta-'+this.group.id].show = false;
    this.internal = this.group;
  }
}
</script>

<style scoped lang="scss">
.forced-pointer {
  ::v-deep .custom-control-label {
    cursor:pointer !important;
  }
}
</style>
